/* LOCAL PREPARED: supported Google website-call configuration, no GA4 loader.
 * The existing native Google tag and consent integration must remain in place.
 * Number replacement is not a call/conversion event or proof of ad attribution.
 */
(function (window, document) {
  'use strict';
  var paths = ['/', '/pages/contact', '/pages/marketing-operations', '/pages/consultation', '/pages/online-consultation', '/pages/office-consultation', '/pages/ai-agent'];
  if (window.location.hostname !== 'sydevelop.com' || paths.indexOf(window.location.pathname) === -1 || window.__sySearchWebsiteCallsInstalled) return;
  window.__sySearchWebsiteCallsInstalled = true;
  var ADS_ID = 'AW-18504354816';
  var DESTINATION = 'AW-18504354816/1RdFCPaX0ZsdEICYyPdE';
  var ORIGINAL_HREF = 'tel:+19162226645';
  var DISPLAY_NUMBER = '(916) 222-6645';
  var registry, records = [], decided = false, configured = false, apiFailed = false;
  var deadline = Date.now() + 2000, timer = null;

  function privacyAvailable() {
    try { return typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' && typeof window.Shopify.customerPrivacy.marketingAllowed === 'function'; }
    catch (_) { return false; }
  }
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true && window.Shopify.customerPrivacy.marketingAllowed() === true; }
    catch (_) { return false; }
  }
  function stopWaiting() { if (timer !== null) { window.clearTimeout(timer); timer = null; } }
  function restore() {
    records.forEach(function (record) {
      try {
        registry.delete(record.anchor);
        if (record.anchor.getAttribute('href') === record.lastHref) record.anchor.setAttribute('href', ORIGINAL_HREF);
        record.texts.forEach(function (text) { if (text.node.data === text.lastText) text.node.data = text.original; });
        record.lastHref = ORIGINAL_HREF;
        record.texts.forEach(function (text) { text.lastText = text.original; });
      } catch (_) { /* Preserve independent DOM changes; no tracking retry. */ }
    });
  }
  function captureAnchors() {
    Array.prototype.forEach.call(document.querySelectorAll('a[href="' + ORIGINAL_HREF + '"]'), function (anchor) {
      if (records.some(function (record) { return record.anchor === anchor; })) return;
      var texts = [], walker = document.createTreeWalker(anchor, window.NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) {
        if (node.data.indexOf(DISPLAY_NUMBER) !== -1) texts.push({ node: node, original: node.data, lastText: node.data });
      }
      records.push({ anchor: anchor, lastHref: ORIGINAL_HREF, texts: texts });
    });
  }
  function replaceNumber(formattedNumber, mobileNumber) {
    if (!allowed()) { restore(); return; }
    if (typeof formattedNumber !== 'string' || typeof mobileNumber !== 'string' || !/^[+()0-9 .-]{7,32}$/.test(formattedNumber)) { restore(); return; }
    var plain = mobileNumber.replace(/^\+/, '');
    if (!/^1[2-9][0-9]{9}$/.test(plain)) { restore(); return; }
    var displayed = formattedNumber.replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
    if (displayed !== plain.slice(1)) { restore(); return; }
    var href = 'tel:+' + plain;
    try {
      captureAnchors();
      records.forEach(function (record) {
        if (!allowed()) { restore(); return; }
        var current = record.anchor.getAttribute('href');
        if (current !== ORIGINAL_HREF && current !== record.lastHref) return;
        record.texts.forEach(function (text) {
          if (text.node.data === text.lastText) {
            text.lastText = text.original.replaceAll(DISPLAY_NUMBER, formattedNumber);
            text.node.data = text.lastText;
          }
        });
        record.lastHref = href;
        record.anchor.setAttribute('href', href);
        registry.add(record.anchor);
      });
      if (!allowed()) restore();
    } catch (_) { restore(); }
  }
  function decide() {
    if (decided) return;
    if (apiFailed || Date.now() > deadline) { decided = true; stopWaiting(); return; }
    if (privacyAvailable() && !allowed()) { decided = true; stopWaiting(); return; }
    if (!privacyAvailable() || typeof window.gtag !== 'function' || document.readyState === 'loading') {
      timer = window.setTimeout(decide, 100); return;
    }
    decided = true; stopWaiting();
    try {
      if (Object.prototype.hasOwnProperty.call(window, '__sySearchWebsiteCallAnchors') || typeof window.WeakSet !== 'function') return;
      registry = new window.WeakSet();
      Object.defineProperty(window, '__sySearchWebsiteCallAnchors', { value: registry, writable: false, configurable: false });
      captureAnchors();
      if (!records.length || !allowed()) return;
      // Mark before dispatch; an uncertain configuration command is not retried.
      configured = true;
      window.gtag('config', ADS_ID, { send_page_view: false, allow_ad_personalization_signals: false });
      if (!allowed()) return;
      window.gtag('config', DESTINATION, {
        phone_conversion_number: DISPLAY_NUMBER,
        phone_conversion_callback: replaceNumber,
        phone_conversion_options: { timeout: 5000, cache: false },
        send_page_view: false,
        allow_ad_personalization_signals: false
      });
    } catch (_) { restore(); }
  }
  document.addEventListener('visitorConsentCollected', function () {
    if (configured && !allowed()) restore();
    // A later consent grant does not restart this page's denied/expired decision.
  });
  try {
    if (!privacyAvailable() && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        apiFailed = Boolean(error); decide();
      });
    }
  } catch (_) { apiFailed = true; }
  decide();
})(window, document);
